// DS: i3.3
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const Edit = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M17.434 3.7l3.3 3.299a1 1 0 01.009 1.406L8.294 21.136a1 1 0 01-.715.301H4.707A1.707 1.707 0 013 19.73v-2.872a1 1 0 01.3-.715L16.029 3.692a1 1 0 011.406.007zM14.14 8.333L5 17.278v2.159h2.158l8.94-9.145-1.958-1.958zm2.579-2.522L15.656 6.85l1.925 1.925 1.04-1.062-1.902-1.901z"
    })));
Edit.displayName = 'Edit';
export default Edit;
